var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#506D85",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.5,
    d: "M21.219 11.219H12.78V2.78a.781.781 0 1 0-1.562 0v8.438H2.78a.781.781 0 1 0 0 1.562h8.438v8.438a.781.781 0 1 0 1.562 0V12.78h8.438a.781.781 0 1 0 0-1.562z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDashboard);
export default __webpack_public_path__ + "static/media/new-dashboard.22a7513ba0b2e7c4b6109fd51f1cd337.svg";
export { ForwardRef as ReactComponent };